const tempusDominus = require('@eonasdan/tempus-dominus').default;

let datepicker = document.getElementsByClassName('datepicker');
let dobpicker = document.getElementsByClassName('dobpicker');
let timepicker = document.getElementsByClassName('timepicker');

if (datepicker) {
    $(datepicker).each(function () {
        $id = $(this).attr('id');
        new tempusDominus.TempusDominus(document.getElementById($id), {
            allowInputToggle: true,
            restrictions: {
                minDate: new Date(),
            },
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: false,
                    hours: false,
                    minutes: false,
                    seconds: false,
                    useTwentyfourHour: false,
                },
                icons: {
                    time: 'fal fa-clock',
                    date: 'fal fa-calendar-alt',
                    up: 'fal fa-chevron-up',
                    down: 'fal fa-chevron-down',
                    previous: 'fal fa-chevron-left',
                    next: 'fal fa-chevron-right',
                    today: 'fal fa-calendar-check',
                    clear: 'fal fa-trash',
                    close: 'fal fa-times',
                },
                buttons: {
                    today: true,
                    close: true,
                    clear: true,
                },
                theme: 'light'
            }
        });
    });
}
if (dobpicker) {
    let now = new Date();
    now.setFullYear(now.getFullYear() - 18);

    $(dobpicker).each(function () {
        $id = $(this).attr('id');

        new tempusDominus.TempusDominus(document.getElementById($id), {
            allowInputToggle: true,
            restrictions: {
                maxDate: now.toISOString(),
            },
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: false,
                    hours: false,
                    minutes: false,
                    seconds: false,
                    useTwentyfourHour: false,
                },
                icons: {
                    time: 'fal fa-clock',
                    date: 'fal fa-calendar-alt',
                    up: 'fal fa-chevron-up',
                    down: 'fal fa-chevron-down',
                    previous: 'fal fa-chevron-left',
                    next: 'fal fa-chevron-right',
                    today: 'fal fa-calendar-check',
                    clear: 'fal fa-trash',
                    close: 'fal fa-times',
                },
                buttons: {
                    today: true,
                    close: true,
                    clear: true,
                },
                theme: 'light',
            },
            defaultDate: now.toISOString(),
        });
    });
}

if (timepicker) {
    $(timepicker).each(function () {
        $id = $(this).attr('id');
        new tempusDominus.TempusDominus(document.getElementById($id), {
            allowInputToggle: true,
            restrictions: {
                enabledHours: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
            },
            display: {
                theme: 'light',
                viewMode: 'clock',
                components: {
                    decades: false,
                    year: false,
                    month: false,
                    date: false,
                    hours: true,
                    minutes: true,
                    seconds: false,
                    useTwentyfourHour: true,
                },
                icons: {
                    time: 'fal fa-clock',
                    date: 'fal fa-calendar-alt',
                    up: 'fal fa-chevron-up',
                    down: 'fal fa-chevron-down',
                    previous: 'fal fa-chevron-left',
                    next: 'fal fa-chevron-right',
                    today: 'fal fa-calendar-check',
                    clear: 'fal fa-trash',
                    close: 'fal fa-times',
                },
                buttons: {
                    close: true,
                    clear: true,
                },
            }
        });
    });
}
